import React, { useState } from 'react';

import Icon from '../../../components/AppIcon';

const SocialAuthSection = ({ onSuccess }) => {
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      bgColor: 'bg-white',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300'
    },
    {
      id: 'github',
      name: 'GitHub',
      icon: 'Github',
      bgColor: 'bg-gray-900',
      textColor: 'text-white',
      borderColor: 'border-gray-900'
    }
  ];

  const handleSocialAuth = async (provider) => {
    setLoadingProvider(provider?.id);
    
    try {
      // Simulate social authentication
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Store authentication state
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userEmail', `user@${provider?.id}.com`);
      
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(`${provider?.name} authentication failed:`, error);
    } finally {
      setLoadingProvider(null);
    }
  };

  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-surface text-text-secondary">Or continue with</span>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {socialProviders?.map((provider) => (
          <button
            key={provider?.id}
            onClick={() => handleSocialAuth(provider)}
            disabled={loadingProvider !== null}
            className={`
              flex items-center justify-center px-4 py-3 border rounded-md
              transition-smooth hover-scale
              ${provider?.bgColor} ${provider?.textColor} ${provider?.borderColor}
              hover:shadow-soft disabled:opacity-50 disabled:cursor-not-allowed
              ${loadingProvider === provider?.id ? 'opacity-75' : ''}
            `}
          >
            {loadingProvider === provider?.id ? (
              <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
            ) : (
              <Icon name={provider?.icon} size={20} />
            )}
            <span className="ml-2 text-sm font-medium">
              {loadingProvider === provider?.id ? 'Connecting...' : provider?.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SocialAuthSection;